// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"957":"3ef032ef","986":"f76e3fce"}[chunkId] + ".css";
};